import { render, staticRenderFns } from "./ActiveCall.vue?vue&type=template&id=1c2f1cb4&scoped=true&"
import script from "./ActiveCall.vue?vue&type=script&lang=js&"
export * from "./ActiveCall.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCall.vue?vue&type=style&index=0&id=1c2f1cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f1cb4",
  null
  
)

export default component.exports